import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'sdSafeResourceUrl', standalone: true })
export class SafeResourceUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(url: string | any[]): SafeUrl {
    if (typeof url === 'string') {
      return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }

    return url;
  }
}
